// Version : 1.0.0
// Author : AGALYA
const ExtraInformationActionType = {
	/** ***************** EXTRA INFORMATION ADD START *********************** */
	EXTRA_INFORMATION_ADD_START: 'extra_information_add_start',
	EXTRA_INFORMATION_ADD_SUCCESS: 'extra_information_add_success',
	EXTRA_INFORMATION_ADD_FAILURE: 'extra_information_add_failure',
	EXTRA_INFORMATION_ADD_RESPONSE_REST_START: 'extra_information_add_response_reset_start',
	EXTRA_INFORMATION_ADD_RESPONSE_CHANGED: 'extra_information_add_response_changed',
	/** ***************** EXTRA INFORMATION ADD END *********************** */
};

export default ExtraInformationActionType;
